import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { NgbDateStruct, NgbDate, NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-news-create',
  templateUrl: './news-create.component.html',
  styleUrls: ['./news-create.component.scss']
})
export class NewsCreateComponent implements OnInit {

  public model: NgbDateStruct;
  public date: { year: number, month: number };
  public modelFooter: NgbDateStruct;

  constructor(private calendar: NgbCalendar, private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  dateVal = null;
  public newsForm: FormGroup;
  public news = [];
  public departments = [];
  public years = [];
  public categories = [];

  selectToday() {
    this.model = this.calendar.getToday();
  }

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/newsbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.dateVal = data.data.date;
            this.newsForm.patchValue({
              _id: data.data._id,
              heading: data.data.heading,
              date: data.data.dateCustom,
              // title: data.data.title,
              image: data.data.image,
              // imagealt: data.data.imagealt,
              description: data.data.description,
              priority: data.data.priority,
              year: data.data.year,
              type: data.data.type,
              department: data.data.department,
              categoryname: data.data.categoryname,
              departmentname: data.data.departmentname,
              coursepagedisplay: data.data.coursepagedisplay,
              homepagedisplay: data.data.homepagedisplay,
              homepagedisplay2: data.data.homepagedisplay2,
              homepagedisplay3: data.data.homepagedisplay3,
              h1_tag_content: data.data.h1_tag_content,
              meta_title: data.data.meta_title,
              meta_keyword: data.data.meta_keyword,
              meta_description: data.data.meta_description,
              content_url: data.data.content_url,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.http.get<any>(this.api_endpoint+'/newsYear/').subscribe(
      data => {
        this.years = data.data.sort(function(a, b) { return Date.parse(a.year) - Date.parse(b.year)  })
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });

    this.http.get<any>(this.api_endpoint+'/newsCategories/').subscribe(
      data => {
        this.categories = data.data
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });

    this.http.get<any>(this.api_endpoint+'/courses/').subscribe(
      data => {
        // console.log(data.data);
        // this.departments = data.data;
        var obj1 = []
      data.data.map(item => {
          return {
            course: item.course,
            courselink: item.courselink,
          }
      }).forEach(item => obj1.push(item));
      var obj2 = obj1.filter(function( obj ) {
        return obj.course !== 'EBAC' && obj.course !== 'PCMB' && obj.course !== 'HEBA' && obj.course !== 'PCMC';
      });
      
      var obj =  obj2.push(
        {'course': 'Placements', 'courselink': 'Placements'},
        {'course': 'Sports', 'courselink': 'Sports'},
        {'course': 'Admissions', 'courselink': 'Admissions'},
        {'course': 'Engineering General', 'courselink': 'Engineering General'},
        {'course': 'Degree General', 'courselink': 'Degree General'},
        {'course': 'School of Business', 'courselink': 'School of Business'},
      );
      this.departments =   obj2.sort( compare );
        // this.departments = data.data.sort( compare );
        function compare( a, b ) {
          if ( a.course < b.course ){
            return -1;
          }
          if ( a.course > b.course ){
            return 1;
          }
          return 0;
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });

    this.newsForm = this.formBuilder.group({
      heading: ['', Validators.required],
      // title: [''],
      date: ['', Validators.required],
      image: ['', Validators.required],
      // imagealt: ['', Validators.required],
      description: ['', Validators.required],
      year: ['', Validators.required],
      type: ['', Validators.required],
      department: ['', Validators.required],
      h1_tag_content: ['', Validators.required],
      meta_title: ['', Validators.required],
      meta_keyword: ['', Validators.required],
      meta_description: ['', Validators.required],
      content_url: ['', Validators.required],
      priority: [''],
      coursepagedisplay: [''],
      homepagedisplay: [''],
      homepagedisplay2: [''],
      homepagedisplay3: [''],
      departmentname: [''],
      categoryname: [''],
      _id: ['']
    })
  }

  getCategory(value) {
    this.http.get<any>(this.api_endpoint+'/newsCategoriesbyid/'+value).subscribe(
      data => {
        this.newsForm.patchValue({
          categoryname: data.data.category
        });
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  getDepartment(value) {
    if(value == 'Placements' || value == 'Sports' || value == 'Admissions' || value == 'Engineering General' || value == 'Degree General'){
      this.newsForm.patchValue({
        departmentname: value
      });
    }else{
      this.http.get<any>(this.api_endpoint+'/coursebycourselink/'+value).subscribe(
        data => {
          this.newsForm.patchValue({
            departmentname: data.data.course
          });
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

  modifyUrl()
  {
    this.newsForm.patchValue({
      content_url: this.newsForm.value.content_url.toLowerCase().replace(/ /g, '-')
    })
  }

  get f() { return this.newsForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.newsForm.invalid) {
      return;
    }

    let monthString = ['', "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let year = this.newsForm.value.date;
    let yearsplit = year.split("-");

    if(this.action == 'Submit'){
    
    var data = {
      "heading" : this.newsForm.value.heading,
      // "title" : this.newsForm.value.title,
      "date" : yearsplit[2] + ' ' + monthString[yearsplit[1].replace(/\b[0]/g, '')] + ' ' + yearsplit[0],
      "dateCustom" : this.newsForm.value.date,
      "dateTimestamp" : Date.parse(this.newsForm.value.date),
      "image" : this.newsForm.value.image,
      // "imagealt" : this.newsForm.value.imagealt,
      "description" : this.newsForm.value.description,
      "priority" : this.newsForm.value.priority,
      "year" : this.newsForm.value.year,
      "type" : this.newsForm.value.type,
      "department" : this.newsForm.value.department,
      "categoryname" : this.newsForm.value.categoryname,
      "departmentname" : this.newsForm.value.departmentname,
      "coursepagedisplay" : this.newsForm.value.coursepagedisplay,
      "homepagedisplay" : this.newsForm.value.homepagedisplay,
      "homepagedisplay2" : this.newsForm.value.homepagedisplay2,
      "homepagedisplay3" : this.newsForm.value.homepagedisplay3,
      "h1_tag_content" : this.newsForm.value.h1_tag_content,
      "meta_title" : this.newsForm.value.meta_title,
      "meta_keyword" : this.newsForm.value.meta_keyword,
      "meta_description" : this.newsForm.value.meta_description,
      "content_url" : this.newsForm.value.content_url,
      "admin" : sessionStorage.getItem('adminName'),
    };
    // console.log(data);
    this.http.post<any>(this.api_endpoint+'/news', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/news/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "heading" : this.newsForm.value.heading,
      // "title" : this.newsForm.value.title,
      "date" : yearsplit[2] + ' ' + monthString[yearsplit[1].replace(/\b[0]/g, '')] + ' ' + yearsplit[0],
      "dateCustom" : this.newsForm.value.date,
      "dateTimestamp" : Date.parse(this.newsForm.value.date),
      "image" : this.newsForm.value.image,
      // "imagealt" : this.newsForm.value.imagealt,
      "description" : this.newsForm.value.description,
      "priority" : this.newsForm.value.priority,
      "year" : this.newsForm.value.year,
      "type" : this.newsForm.value.type,
      "department" : this.newsForm.value.department,
      "categoryname" : this.newsForm.value.categoryname,
      "departmentname" : this.newsForm.value.departmentname,
      "coursepagedisplay" : this.newsForm.value.coursepagedisplay,
      "homepagedisplay" : this.newsForm.value.homepagedisplay,
      "homepagedisplay2" : this.newsForm.value.homepagedisplay2,
      "homepagedisplay3" : this.newsForm.value.homepagedisplay3,
      "h1_tag_content" : this.newsForm.value.h1_tag_content,
      "meta_title" : this.newsForm.value.meta_title,
      "meta_keyword" : this.newsForm.value.meta_keyword,
      "meta_description" : this.newsForm.value.meta_description,
      "content_url" : this.newsForm.value.content_url,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.newsForm.value._id,
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/news/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/news/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
